var map = {
	"./BGDF.png": 4353,
	"./BGDFDC.png": 4177,
	"./BGDFDG.png": 4562,
	"./BGDL.png": 1755,
	"./BGFD.png": 9710,
	"./BGGF.png": 8910,
	"./BGJJBX.png": 8078,
	"./BGJJBXG.png": 7818,
	"./BGLL.png": 419,
	"./BGMVP.png": 5525,
	"./BGTCJL.png": 8458,
	"./BGYCS.png": 9390
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5410;